const __WEBPACK_NAMESPACE_OBJECT__ = require("@braintree/browser-detection");